export default __webpack_public_path__ + "static/media/ARPHICPL.11c3c167.TXT";